var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"btn-sm",attrs:{"variant":"danger","title":"Delete"},on:{"click":function($event){return _vm.deleteItem(_vm.params.data)}}},[_c('i',{staticClass:"fas fa-fw fa-trash"})])}
var staticRenderFns = []

export { render, staticRenderFns }